import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { viewModes } from 'utils/app-configs';
import * as actionTypes from './planning-board-constants';

export const viewMode = handleActions(
  {
    [actionTypes.SET_VIEW_MODE]: (state, { payload }) => payload,
  },
  viewModes.TOPBOTTOM,
);

export const fullScreen = handleActions(
  {
    [actionTypes.SET_FULLSCREEN]: (state, { payload }) => payload,
  },
  false,
);

export const showTravelTime = handleActions(
  {
    [actionTypes.TOGGLE_SHOW_TRAVEL_TIME]: (state, { payload }) => payload,
  },
  true,
);

export default combineReducers({
  viewMode,
  fullScreen,
  showTravelTime,
});
